// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Social[data-v-17739dbd]{display:flex;align-items:center;justify-content:center}.Social img[data-v-17739dbd]{height:32px}.Social a[data-v-17739dbd]:not(:last-child){margin-right:15px}.Social .Facebook[data-v-17739dbd]{height:30px}.Social .Twitter[data-v-17739dbd]{height:34px}", ""]);
// Exports
module.exports = exports;
